module.exports = __webpack_public_path__ + "images/directory/featured-hero/customfields@2x.c5bc67d848b27429130f.png";


//////////////////
// WEBPACK FOOTER
// ./resources/images/directory/featured-hero/customfields@2x.png
// module id = zYA8
// module chunks = 2